import * as React from "react"
import MainNavLink from "./main-nav-link"
import Logo from "./logo"
import { Link } from "gatsby"
import SocialIcon from "./social-icon"

const Footer = () => {
  const navLinks = [
    {
      title: "Listings",
      to: "/listings",
    },
    {
      title: "Buyers",
      to: "/buyers",
    },
    {
      title: "Sellers",
      to: "/sellers",
    },
    {
      title: "Charter",
      to: "/yachts-for-charter",
    },
    {
      title: "About",
      to: "/about",
    },
    {
      title: "More Luxe",
      to: "/more-luxe",
    },
    {
      title: "Contact",
      to: "/contact",
    },
  ]

  return (
    <footer className={"bg-navy"}>
      <div className={"max-w-6xl mx-auto px-4 sm:px-6"}>
        <div
          className={
            "py-12 flex flex-col items-center justify-center gap-12 lg:gap-6"
          }
        >
          <Link to={"/"}>
            <Logo className={"h-20"} variant={"dark"} />
          </Link>

          <nav className={"flex flex-grow"}>
            <ul
              className={
                "flex flex-col lg:flex-row items-center gap-2 lg:gap-12"
              }
            >
              {navLinks.map((link, index) => (
                <MainNavLink key={index} title={link.title} to={link.to} />
              ))}
            </ul>
          </nav>
        </div>
      </div>
      <div className={"max-w-6xl mx-auto px-4 sm:px-6"}>
        <div
          className={
            "flex flex-col lg:flex-row items-center justify-between border-t border-navy-800 border-solid py-4"
          }
        >
          <div className={"text-xs lg:text-sm text-white font-light"}>
            © Luxe Yachts {new Date().getFullYear()}. All rights reserved{" "}
          </div>

          <div className={"text-xs lg:text-sm text-white font-light "}>
            {" "}
            <ul className={"flex flex-row gap-2 items-center"}>
              <li>
                <Link
                  to={"/privacy"}
                  className={
                    "text-white mr-4 hover:text-blue transition duration-500 ease-in-out"
                  }
                >
                  Privacy Policy
                </Link>{" "}
                <span className={"text-blue"}>/</span>
              </li>
              <li>
                <a
                  href={"https://www.facebook.com/luxeyachts"}
                  target={"_blank"}
                  rel={"noreferrer"}
                  className={
                    "group h-7 w-7 hover:bg-blue transition duration-500 ease-in-out rounded-full flex items-center justify-center"
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                    className={
                      "h-4 text-blue group-hover:text-white fill-current transition duration-500 ease-in-out"
                    }
                  >
                    <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href={"https://www.instagram.com/luxeyachts.co.uk"}
                  target={"_blank"}
                  rel={"noreferrer"}
                  className={
                    "group h-7 w-7 hover:bg-blue transition duration-500 ease-in-out rounded-full flex items-center justify-center"
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    className={
                      "h-4 text-blue group-hover:text-white fill-current transition duration-500 ease-in-out"
                    }
                  >
                    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href={"https://www.youtube.com/@TiffanyHowieYachtBroker"}
                  target={"_blank"}
                  rel={"noreferrer"}
                  className={
                    "group h-7 w-7 hover:bg-blue transition duration-500 ease-in-out rounded-full flex items-center justify-center"
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    className={
                      "h-4 text-blue group-hover:text-white fill-current transition duration-500 ease-in-out"
                    }
                  >
                    <path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
